import { CartHistory } from "@/shared/dtos/CartHistory";
import { ssmHttpService } from "./http-service";
import { API } from "../api";

export class tienda_cart_history_local_service {
  public static storage_key: string = "tienda_cart_history";

  /**
   * Carga el CartHistory desde localStorage.
   * @returns CartHistory o null si no existe / no es válido.
   */
  public static load(): CartHistory {
    try {
      var raw = localStorage.getItem(this.storage_key);
      if (!raw) { return new CartHistory(); }

      var parsed: any;
      try {
        parsed = JSON.parse(raw);
      } catch (_e) {
        return new CartHistory();
      }
      return new CartHistory(parsed);
    } catch (_e) {
      return new CartHistory();
    }
  }

  /**
   * Guarda el CartHistory en localStorage (usa toPlain()).
   */
  public static save(model: CartHistory): void {
    try {
      var payload: any = model && typeof (model as any).toPlain === "function"
        ? (model as any).toPlain()
        : model;
      localStorage.setItem(this.storage_key, JSON.stringify(payload));

      ssmHttpService.post(API.carts+'/ingest/false', payload);
    } catch (_e) { /* noop */ }
  }

  /**
   * Elimina el CartHistory del localStorage.
   */
  public static remove(): void {
    try {
      localStorage.removeItem(this.storage_key);
    } catch (_e) { /* noop */ }
  }
}

export const TiendaCartHistoryLocalService = tienda_cart_history_local_service;
